module.exports = __webpack_public_path__ + "media/images/frontend/logo-b7331868bfaca44785613fe45062e629.svg";